<template>

<div v-show="dataUser">
  <services-field-group-by-hub v-if="hasRealHubs"
                               :affiliated-service="internalDataUser.affiliated_service"
                               :available-services="filteredServices"
                               :selected-services="internalDataUser.services"
                               :available-hubs="disabledConditions && dataUser.entity ? dataUser.entity.hubs : availableHubs"
                               :disabled-conditions="disabledConditions"
                               :field-name-addition="fieldNameAddition"
                               :is-manager="isManager"
                               :isInternal="isInternal"
                               :small="small"
                               :collapseHubs="collapseHubs"
                               @change="onChange('services', $event)" />

  <services-field v-else
                  :available-services="filteredServices"
                  :disabled-conditions="disabledConditions"
                  :is-manager="isManager"
                  :field-name-addition="fieldNameAddition"
                  :user="internalDataUser"
                  @change="onChange('services', $event)" />

  <p v-if="alertMultiService" class="pop-up"> {{ $t("models.user.alert_multi_choice_services")}} </p>

  <div v-if="isInternal && !isManager">
    <affiliated-service-field id="affiliated_service"
                              :label="$t('models.user.affiliated_service')"
                              :value="internalDataUser.affiliated_service"
                              :disabled="disabledConditions"
                              :options="filteredServices"
                              :has-real-hubs="hasRealHubs"
                              :field-name-addition="fieldNameAddition"
                              :available-hubs="disabledConditions && dataUser.entity ? dataUser.entity.hubs : availableHubs"
                              @change="onChange('affiliated_service', $event)"
                              :required="affiliatedServiceValidationRules" />
  </div>

</div>
</template>

<script>
import HubsField from '@/components/users/form/HubsField'
import AffiliatedServiceField from '@/components/users/form/AffiliatedServiceField'
import ServicesField from '@/components/users/form/ServicesField'
import ServicesFieldGroupByHub from '@/components/users/form/ServicesFieldGroupByHub'

const { detect } = require('detect-browser');

export default {
  name: 'ServicesWithHubsFilter',
  inject: ['$validator'],
  props: {
    availableHubs: Array,
    availableServices: Array,
    disabledConditions: Boolean,
    dataUser: Object,
    isManager: Boolean,
    isInternal: Boolean,
    fieldNameAddition: { type: [String, Number], default: null },
    collapseHubs: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    entity_id: { type: Number, default: null }
  },
  components: {
    HubsField,
    AffiliatedServiceField,
    ServicesField,
    ServicesFieldGroupByHub
  },
  data() {
    return {
      internalDataUser: Object.assign({}, this.dataUser),
      selectedHubs: []
    }
  },
  watch: {
    dataUser: {
      handler(){
        this.internalDataUser = Object.assign({}, this.dataUser)
        if (this.dataUser.resource_type == 'extern') {
          this.internalDataUser.affiliated_service = null
        }
      },
      deep: true
    }
  },
  methods: {
    onChange(fieldName, value) {
      this.$emit('change', { field: fieldName, value: value })

      if(fieldName == "affiliated_service" && value) {
        var affiliatedService = this.availableServices.filter((service) => service.id == value.id)
        var selectedServices = this.internalDataUser.services
        $('#hub-id-' + value.hub_id).collapse('show')
        if(affiliatedService.length > 0 && selectedServices.find((service) => service.id == affiliatedService[0].id) === undefined){
          selectedServices = this.internalDataUser.services.concat(affiliatedService)
          this.$emit('change', { field: "services", value: selectedServices })
        }
      }
    }
  },
  computed: {
    alertMultiService() {
      return !this.hasRealHubs && this.internalDataUser.services.length === 1
    },
    affiliatedServiceValidationRules(){
      return this.isInternal ? 'required' : ''
    },
    entityId() {
      if(this.entity_id) {
        return this.entity_id
      }

      if(this.internalDataUser.entity) {
        return this.internalDataUser.entity.id
      }

      return this.internalDataUser.entity_id;
    },
    hasRealHubs() {
      var hubs = this.availableHubs

      if(this.internalDataUser &&
         this.internalDataUser.entity &&
         this.internalDataUser.entity.hubs) {
        hubs = this.internalDataUser.entity.hubs
      }

      return hubs.filter(hub => {
        return (!hub.is_fake && hub.entity_id == this.entityId)
      }).length > 0
    },
    selectedHubsIds() {
      return this.selectedHubs.map(hub => hub.id)
    },
    hasSelectedHubs() {
      return this.selectedHubs.length > 0
    },
    filteredServices() {
      if(!this.hasSelectedHubs) {
        return this.availableServices;
      }

      return this.availableServices.filter(service => this.selectedHubsIds.includes(service.hub_id))
    },
    filteredServicesIds() {
      return this.filteredServices.map(service => service.id)
    },
  }
}
</script>
<style scoped>
.pop-up {
  background-color: #F2F2F2;
  color: #6D7173;
  border-radius: 7px;
  padding: 7px 0;
  text-align: center;
  font-size: 10px;
  letter-spacing: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/users/form/ServicesWithHubsFilter.vue